import {createSelector, MemoizedSelector} from '@ngrx/store';
import {chacrasGeoAdapter, ChacrasGeoState} from './chacras-geo.state';

import {FeaturesState, selectFeatures} from '../../../features.state';
import {ChacraGeo} from "../../../../../chacra-core/models/chacra";

export const getError = (state: ChacrasGeoState): any => state.error;

export const getIsLoading = (state: ChacrasGeoState): boolean =>
  state.isLoading;

export const selectChacrasGeoState = createSelector(selectFeatures,
  (state: FeaturesState) => state.chacrasGeo
);

export const selectAllChacrasGeo: (state: object) => ChacraGeo[] = chacrasGeoAdapter.getSelectors(
  selectChacrasGeoState
).selectAll;

export const selectChacraGeoById = (id: string) =>
  createSelector(
    selectAllChacrasGeo,
    (allChacras: ChacraGeo[]) => {
      if (allChacras) {
        return allChacras.find(c => c.idUnico === id);
      } else {
        return null;
      }
    }
  );

export const selectChacrasGeoError: MemoizedSelector<object, any> = createSelector(
  selectChacrasGeoState,
  getError
);

export const selectChacrasGeoIsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectChacrasGeoState,
  getIsLoading
);
